import { TablePaginationConfig } from "../types/common";

export const DEFAULT_TABLE_PAGINATION: TablePaginationConfig = {
  page: 1,
  size: 10,
  firstDoc: undefined,
  secondDoc: undefined,
  lastDoc: undefined,
  maxPage: 1,
}